import Customers from "pages/customers";
import CustomerDetails from "pages/customers/detail";
import StaffUsers from "pages/staff";

const routes = [
  // Customers
  {
    path: `/customers`,
    exact: true,
    auth: true,
    component: Customers,
  },
  {
    path: `/customers/:customerId`,
    exact: true,
    auth: true,
    component: CustomerDetails,
  },
  {
    path: `/staff-users`,
    exact: true,
    auth: true,
    component: StaffUsers,
  },
  {
    path: `/staff-users/:staffId`,
    exact: true,
    auth: true,
    component: CustomerDetails,
  },
];

export default routes;
